import { defineStore } from 'pinia';
import { authenticationStore } from './AuthenticationStore';
const APP_BAR_HEIGHT = 48;
const BAR_HEIGHT = 40;
const INSECURE_DIALOG = 'insecureDialog';

interface State {
  windowHeight: number;
  windowWidth: number;
  preOpenChangePasswordDialog: boolean;
  insecurePassword: boolean;
}

export const appStore = defineStore('appStore', {
  state: (): State => ({
    windowHeight: window.innerHeight,
    windowWidth: window.innerWidth,
    preOpenChangePasswordDialog: false,
    insecurePassword: localStorage.getItem(INSECURE_DIALOG) === 'true'
  }),
  getters: {
    getContainerHeight: (state): number =>
      state.windowHeight -
      (authenticationStore().numberOfAppBars * BAR_HEIGHT + APP_BAR_HEIGHT),
    getPreOpenInscurePasswordDialog: (): boolean =>
      localStorage.getItem(INSECURE_DIALOG) === 'true'
  },
  actions: {
    setInsecurePassword(value: boolean) {
      this.insecurePassword = value;
      localStorage.setItem(INSECURE_DIALOG, value.toString());
    }
  }
});
